<script setup lang="ts">

import { RowSlot } from '@shared/ui/other'
import { NativeSelect } from '@shared/ui/fields'

import { useTutorKanbanSelectStage } from '../../model/use-tutor-kanban-select-stage.hook'

defineOptions({
  name: 'TutorKanbanSelectStage',
})

const {
  refOptions,
  getInitialValue,
  handleChange,
} = useTutorKanbanSelectStage()
</script>

<template>
  <RowSlot
    label="Stage"
    tooltip="Some stage options are unavailable for certain tutor categories."
  >
    <NativeSelect
      name="stage"
      :options="refOptions"
      :value="getInitialValue()"
      @change="handleChange"
    />
  </RowSlot>
</template>
